module.exports = __webpack_public_path__ + "media/images/payment/mbway-a59b2b377830f8670ba28e79d1b575a5.svg";